import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import { Label } from "src/@/components/ui/label";
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Switch } from 'src/@/components/ui/switch';
import { Textarea } from 'src/@/components/ui/textarea';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { Skeleton } from 'src/@/components/ui/skeleton';
import { shouldBlockWhatsAppBusiness } from 'src/utils/serviceWindow.utils';

import { verifyFeatures } from 'src/utils/functions';


// ----------------------------------------------------------------------

export default function ModalTransferirChat({
  stateModalTransferirChatProps,
  closeModalTransferirChat,
  valueTransferirChat,
  actionTipoTransferencia,
  valorEscolhidoUsuarioProps,
  valorEscolhidoSetorProps,
  handleUsuario,
  handleSetor,
  handleSelectAgent,
  listaUsuariosProps,
  listaSetoresProps,
  submitTranferirChat,
  onlineUsers,
  loadingTransferirChat,
  cliente,
  chat,
  changeNoteText,
  changeCreateNote,
  noteText,
  createNote,
  listaFunilCards = [],
  loadingFunilCards = false,
  transferirFunilCard = false,
  setTransferirFunilCard,
  selectedFunilCardIds = [],
  setSelectedFunilCardIds,
}) {
  const { t } = useTranslation();

  function validaBotaoTransferir() {
    if (valueTransferirChat === '') return true;
    if (!valorEscolhidoSetorProps && !valorEscolhidoUsuarioProps) return true;
    if (transferirFunilCard && selectedFunilCardIds.length === 0) return true;
    return false;
  };

  const toggleFunilCard = (cardId) => {
    setSelectedFunilCardIds((prev) =>
      prev.includes(cardId) ? prev.filter((id) => id !== cardId) : [...prev, cardId]
    );
  };

  const showFunilCards = loadingFunilCards || listaFunilCards.length > 0;
  
  const [isSendMessages, setIsSendMessages] = useState(false);
  const [transferProprietary, setTransferProprietary] = useState(false);
  const [isWhatsAppBusinessOutsideWindow, setIsWhatsAppBusinessOutsideWindow] = useState(false);

  // Janela de atendimento em src/utils/serviceWindow.utils.js: 24h da última mensagem
  // do cliente, 72h quando a conversa veio de um anúncio (Click-to-WhatsApp).
  const checkWhatsAppBusinessValidity = () => {
    if (!chat) return;
    setIsWhatsAppBusinessOutsideWindow(shouldBlockWhatsAppBusiness(chat));
  };

  useEffect(() => {
    checkWhatsAppBusinessValidity();
  }, [chat, stateModalTransferirChatProps]);

  return (

    <Dialog 
      open={stateModalTransferirChatProps} 
      onOpenChange={closeModalTransferirChat}
    >
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>{t('chat.transfer.title')}</DialogTitle>
        </DialogHeader>
        <div className='min-w-[400px] space-y-6'>
          <div className="mt-3">
            <RadioGroup value={valueTransferirChat} onValueChange={actionTipoTransferencia} className="flex flex-row gap-6">
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="setores" id="setores" />
                <Label htmlFor="setores">{t('chat.transfer.sectors')}</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="usuarios" id="usuarios" />
                <Label htmlFor="usuarios">{t('chat.transfer.users')}</Label>
              </div>
            </RadioGroup>
          </div>

          <div className="overflow-hidden space-y-4">
            {valueTransferirChat === 'usuarios' && (
              <div className='flex flex-col gap-4'>
              <SelectZui
                value={valorEscolhidoUsuarioProps}
                list={listaUsuariosProps}
                fullWidth
                onChange={event => {
                  handleUsuario(event);
                }}
                itemSelect={(item) => (
                  <SelectItem key={item._id} value={item._id}>
                    {item.nomeFantasia}
                  </SelectItem>
                )}
              />
              {verifyFeatures(cliente?.features || [], 'chats.wallet') && (
              <div className="flex items-center gap-2">
              <Switch
                id="terms"
                checked={transferProprietary}
                onCheckedChange={value => {
                  setTransferProprietary(value)
                }}
              />
              <label
                htmlFor="terms"
                className="text-xs font-medium"
              >
                {t('chat.transfer.transferOwner')}
              </label>
            </div>
              )}
              </div>
            
            )}


            {valueTransferirChat === 'setores' && (
              <div className='flex flex-col gap-4'>
                <SelectZui
                  value={valorEscolhidoSetorProps}
                  list={listaSetoresProps}
                  fullWidth
                  onChange={event => {
                    handleSetor(event);
                  }}
                  itemSelect={(item) => (
                    <SelectItem key={item._id} value={item._id}>
                      {item.nome_setor}
                    </SelectItem>
                  )}
                />
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            <Switch
              id="terms"
              checked={isSendMessages}
              onCheckedChange={(value) => setIsSendMessages(value)}
            />
            <label
              htmlFor="terms"
              className="text-xs font-medium"
            >
              {t('chat.transfer.sendTransferMessage')}
            </label>
          </div>
          
          {isWhatsAppBusinessOutsideWindow && (
            <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-md">
              <p className="text-xs text-yellow-800">
                {t(
                  'chat.transfer.whatsappBusinessTemplateHint',
                  'Fora da janela de atendimento o WhatsApp só aceita template. Será enviado o template de transferência configurado no canal.'
                )}
              </p>
            </div>
          )}

          {showFunilCards && (
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Switch
                  id="transferirFunilCard"
                  checked={transferirFunilCard}
                  disabled={loadingFunilCards}
                  onCheckedChange={(value) => {
                    setTransferirFunilCard(value);
                    if (!value) return setSelectedFunilCardIds([]);
                    if (listaFunilCards.length === 1) setSelectedFunilCardIds([listaFunilCards[0]._id]);
                  }}
                />
                <label htmlFor="transferirFunilCard" className="text-xs font-medium">
                  {t('chat.transfer.transferFunilCard')}
                </label>
              </div>

              {transferirFunilCard && (
                <div className="rounded-xl border border-violet-100 bg-violet-50/50 p-3 space-y-2 dark:border-violet-500/20 dark:bg-violet-500/5">
                  {loadingFunilCards
                    ? [...Array(2)].map((_, i) => <Skeleton key={i} className="h-11 w-full rounded-lg" />)
                    : listaFunilCards.map((card) => (
                      <label
                        key={card._id}
                        className="flex items-start gap-2.5 rounded-lg bg-white border border-gray-100 px-3 py-2 cursor-pointer hover:border-violet-200 transition-colors dark:bg-[#222529] dark:border-[#383838]"
                      >
                        <Checkbox
                          checked={selectedFunilCardIds.includes(card._id)}
                          onCheckedChange={() => toggleFunilCard(card._id)}
                          className="mt-0.5"
                        />
                        <span className="flex flex-col min-w-0">
                          <span className="text-xs font-medium text-gray-900 truncate dark:text-gray-100">
                            {card.nomeFunil}{card.nomeEstagio ? ` — ${card.nomeEstagio}` : ''}
                          </span>
                          <span className="text-[11px] text-gray-500 truncate dark:text-[#ABABAD]">
                            {[card.nome, card.nomeUsuario && t('chat.transfer.funilCardCurrentOwner', { name: card.nomeUsuario })]
                              .filter(Boolean)
                              .join(' · ')}
                          </span>
                        </span>
                      </label>
                    ))}

                  {valueTransferirChat === 'setores' && (
                    <p className="text-[11px] text-gray-500 dark:text-[#ABABAD]">
                      {t('chat.transfer.funilCardPendingHint')}
                    </p>
                  )}
                  {!loadingFunilCards && selectedFunilCardIds.length === 0 && (
                    <p className="text-[11px] text-amber-700 dark:text-amber-400">
                      {t('chat.transfer.funilCardSelectAtLeastOne')}
                    </p>
                  )}
                </div>
              )}
            </div>
          )}

          <div className="flex items-center gap-2">
            <Switch
              id="createNote"
              checked={createNote}
              onCheckedChange={value => {
                changeCreateNote(value);
                if (!value) {
                  changeNoteText('');
                }
              }}
            />
            <label
              htmlFor="createNote"
              className="text-xs font-medium"
            >
              {t('chat.transfer.createNote')}
            </label>
          </div>

          {createNote && (
            <div className="space-y-2">
              <Label htmlFor="noteText" className="text-xs font-medium">
                {t('chat.transfer.noteLabel')}
              </Label>
              <Textarea
                id="noteText"
                value={noteText}
                onChange={(e) => changeNoteText(e.target.value)}
                placeholder={t('chat.transfer.notePlaceholder')}
                rows={4}
                className="resize-none"
              />
            </div>
          )}

        </div>
        
        <DialogFooter className='mt-12'>
          <Button
            disabled={validaBotaoTransferir() || loadingTransferirChat}
            className='w-full '
            onClick={async () => {
              await submitTranferirChat(
                isSendMessages,
                transferProprietary,
                createNote ? noteText : '',
                transferirFunilCard ? selectedFunilCardIds : []
              );
              setIsSendMessages(true);
              changeCreateNote(false);
              changeNoteText('');
            }}
          >
            {loadingTransferirChat ? t('chat.transfer.transferring') : t('chat.transfer.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>

  );
}
